/* PSR ORDER REQUEST START */
(function () {
    const BACKEND_ENDPOINT = "";
    /*
     * Future Phase 2 note:
     * Only configure BACKEND_ENDPOINT with a secure backend, Zapier/Make hook, or custom app URL.
     * The Shopify Admin API token must live on that secure backend and must never be exposed in theme code.
     */

    function getValue(form, selector) {
        return form.querySelector(selector)?.value?.trim?.() || "";
    }

    function getCartData() {
        const source = document.getElementById("PSROrderRequestCartData");
        if (!source) return { items: [], estimated_subtotal: "" };

        try {
            return JSON.parse(source.textContent);
        } catch (error) {
            console.error("PSR order request cart payload could not be parsed:", error);
            return { items: [], estimated_subtotal: "" };
        }
    }

    function buildOrderRequestPayload(form) {
        const cartData = getCartData();

        return {
            customer: {
                name: getValue(form, "#PSRContactName"),
                company: getValue(form, "#PSRContactCompany"),
                email: getValue(form, "#PSRContactEmail"),
                phone: getValue(form, "#PSRContactPhone"),
            },
            fulfillment_preference: getValue(form, "#PSRFulfillmentPreference"),
            preferred_date: getValue(form, "#PSRPreferredDate"),
            notes: getValue(form, "#PSRNotes"),
            items: cartData.items || [],
            estimated_subtotal: cartData.estimated_subtotal || "",
            source: "psr_order_request_theme",
            submitted_at: new Date().toISOString(),
        };
    }

    function buildHumanReadableDetails(payload) {
        const itemDetails = payload.items.length
            ? payload.items
                  .map(function (item, index) {
                      return [
                          "Item " + (index + 1),
                          "Product title: " + item.product_title,
                          "Variant title: " + (item.variant_title || "Default"),
                          "SKU: " + (item.sku || "N/A"),
                          "Quantity: " + item.quantity,
                          "Unit price: " + item.unit_price,
                          "Line total: " + item.line_total,
                          "Product URL: " + item.product_url,
                          "Variant ID: " + item.variant_id,
                          "Product ID: " + item.product_id,
                      ].join("\n");
                  })
                  .join("\n\n")
            : "No items in order request.";

        return [
            "PSR Order Request",
            "",
            "Customer name: " + payload.customer.name,
            "Company: " + (payload.customer.company || "N/A"),
            "Email: " + payload.customer.email,
            "Phone: " + payload.customer.phone,
            "Pickup/delivery preference: " + payload.fulfillment_preference,
            "Preferred date: " + (payload.preferred_date || "N/A"),
            "Notes: " + (payload.notes || "N/A"),
            "Estimated subtotal: " + payload.estimated_subtotal,
            "Submitted at: " + payload.submitted_at,
            "",
            "Items:",
            itemDetails,
        ].join("\n");
    }

    async function submitOrderRequestToBackend(payload) {
        if (!BACKEND_ENDPOINT) return { skipped: true };

        return fetch(BACKEND_ENDPOINT, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
        });
    }

    function prepareOrderRequestForm(form) {
        const payload = buildOrderRequestPayload(form);
        const payloadField = form.querySelector("#PSROrderRequestPayload");
        const detailsField = form.querySelector("#PSROrderRequestDetails");

        if (payloadField) payloadField.value = JSON.stringify(payload, null, 2);
        if (detailsField) detailsField.value = buildHumanReadableDetails(payload);

        return payload;
    }

    document.addEventListener("submit", async function (event) {
        const form = event.target.closest("#PSROrderRequestForm");
        if (!form) return;

        const payload = prepareOrderRequestForm(form);
        if (!BACKEND_ENDPOINT) return;

        event.preventDefault();
        try {
            await submitOrderRequestToBackend(payload);
            form.submit();
        } catch (error) {
            console.error("PSR order request backend submission failed:", error);
            form.submit();
        }
    });

    document.addEventListener("input", function (event) {
        const form = event.target.closest("#PSROrderRequestForm");
        if (form) prepareOrderRequestForm(form);
    });

    window.PSROrderRequest = {
        buildOrderRequestPayload,
        prepareOrderRequestForm,
        submitOrderRequestToBackend,
    };
})();
/* PSR ORDER REQUEST END */
